import List from './List';
import Create from './Create';
import Edit from './Edit';
import Bulk from './Bulk';

export { List, Create, Edit, Bulk };



// WEBPACK FOOTER //
// ./src/pages/Admin/Interviews/index.js